import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TemplateSheets from "./TemplateSheets";
import DatasetUpload from "./DatasetUpload";
import IconButton from "../../../packages/IconButton";
import CustomModal from "../../../packages/CustomModal";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../../utils/session";
import {
  FileExclamation,
  InfoCircle,
  QuestionIcon,
  UploadIcon,
} from "../../../assets/icons";
import {
  LOCAL_STORAGE_KEYS,
  TROUBLESHOOTING_TOPICS,
} from "../../../constants/global.constants";

const LeftPanel = ({
  uploadedFiles,
  totalTrainCount,
  selectedTrain,
  sheetNames,
  allTrainsStatus,
  setTempSelectedTrain,
  onRefreshTrainTabs,
}) => {
  const { t } = useTranslation();
  const [isTroubleshootingOpen, setIsTroubleshootingOpen] = useState(false);

  useEffect(() => {
    const troubleshootingReadTopics = JSON.parse(
      getLocalStorageItem(LOCAL_STORAGE_KEYS.TROUBLESHOOTING_READ_TOPICS) ||
        "[]",
    );

    if (
      !troubleshootingReadTopics.includes(TROUBLESHOOTING_TOPICS.DATASET_UPLOAD)
    ) {
      setIsTroubleshootingOpen(true);
    }
  }, []);

  const onTroubleshootingOpen = () => {
    setIsTroubleshootingOpen(true);
  };

  const onTroubleshootingClose = () => {
    const troubleshootingReadTopics = JSON.parse(
      getLocalStorageItem(LOCAL_STORAGE_KEYS.TROUBLESHOOTING_READ_TOPICS) ||
        "[]",
    );

    if (
      !troubleshootingReadTopics.includes(TROUBLESHOOTING_TOPICS.DATASET_UPLOAD)
    ) {
      const updatedTroubleshootingReadTopics = [
        ...troubleshootingReadTopics,
        TROUBLESHOOTING_TOPICS.DATASET_UPLOAD,
      ];
      setLocalStorageItem(
        LOCAL_STORAGE_KEYS.TROUBLESHOOTING_READ_TOPICS,
        JSON.stringify(updatedTroubleshootingReadTopics),
      );
    }

    setIsTroubleshootingOpen(false);
  };

  const troubleshootingSections = [
    {
      icon: FileExclamation,
      titleKey: "helpInformation.datasetTroubleshootPrepareTemplate",
      itemKeys: [
        "helpInformation.datasetTroubleshootPrepareTemplate1",
        "helpInformation.datasetTroubleshootPrepareTemplate2",
        "helpInformation.datasetTroubleshootPrepareTemplate3",
      ],
    },
    {
      icon: UploadIcon,
      titleKey: "helpInformation.datasetTroubleshootUploadingData",
      itemKeys: [
        "helpInformation.datasetTroubleshootUploadingData1",
        "helpInformation.datasetTroubleshootUploadingData2",
        "helpInformation.datasetTroubleshootUploadingData3",
      ],
    },
    {
      icon: InfoCircle,
      titleKey: "helpInformation.datasetTroubleshootIfSomethingDoesntLoad",
      itemKeys: [
        "helpInformation.datasetTroubleshootIfSomethingDoesntLoad1",
        "helpInformation.datasetTroubleshootIfSomethingDoesntLoad2",
        "helpInformation.datasetTroubleshootIfSomethingDoesntLoad3",
        "helpInformation.datasetTroubleshootIfSomethingDoesntLoad4",
      ],
    },
  ];

  return (
    <div className="analyse-data-left-panel">
      <div className="ro-card-header">
        <div className="teal-heading">{t("analyseData.datasetUpload")}</div>
        <IconButton onClick={onTroubleshootingOpen}>
          <QuestionIcon />
        </IconButton>
      </div>
      <TemplateSheets />
      <DatasetUpload
        uploadedFiles={uploadedFiles}
        totalTrainCount={totalTrainCount}
        selectedTrain={selectedTrain}
        sheetNames={sheetNames}
        allTrainsStatus={allTrainsStatus}
        setTempSelectedTrain={setTempSelectedTrain}
        onRefreshTrainTabs={onRefreshTrainTabs}
      />

      {isTroubleshootingOpen && (
        <CustomModal
          header={
            <div className="dataset-troubleshoot-dialog__title">
              <span>{t("helpInformation.datasetTroubleshootTitle")}</span>
            </div>
          }
          onModalClose={onTroubleshootingClose}
          confirmBtn={t("ValueStrings.okay")}
          custombodyclass="dataset-troubleshoot-dialog__body"
          width="850px"
          hideCloseIcon
        >
          <div className="dataset-troubleshoot-dialog__grid">
            {troubleshootingSections.map(
              ({ icon: Icon, titleKey, itemKeys }) => (
                <div
                  className="dataset-troubleshoot-dialog__column"
                  key={titleKey}
                >
                  <div className="dataset-troubleshoot-dialog__column-title">
                    <Icon className="dataset-troubleshoot-dialog__icon" />
                    <span>{t(titleKey)}</span>
                  </div>
                  <ul className="dataset-troubleshoot-dialog__list">
                    {itemKeys.map((itemKey) => (
                      <li key={itemKey}>{t(itemKey)}</li>
                    ))}
                  </ul>
                </div>
              ),
            )}
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default LeftPanel;
